import { createReducer, on } from '@ngrx/store';
import { UserType, UserTypeWithOrders } from '../../../../../../shared/schemas/userSchema';
import { addUserToStore, deleteUserStore, setCurrentUser, updateOrderInvoice, updateUserinStore } from './usersSlice.actions';
export interface UsersState {
  allUsers: UserTypeWithOrders[];   
  currentUser: UserType | null; 
}

export const initialUsersState: UsersState = {
  allUsers: [],
  currentUser: null,
};


export const usersReducer = createReducer(
  initialUsersState,
  on(addUserToStore, (state: UsersState, { user }) => {
    // Upsert: if the user already exists, replace with the fresh copy so
    // balance / hasAccess / orders stay current. The previous "skip if
    // present" implementation was the root cause of stale balances after
    // a refresh — fresh API data was silently discarded.
    const index = state.allUsers.findIndex(u => u._id === user._id);
    if (index >= 0) {
      const next = [...state.allUsers];
      next[index] = user;
      return { ...state, allUsers: next };
    }
    return {
      ...state,
      allUsers: [...state.allUsers, user],
    };
  }),
  on(setCurrentUser, (state: UsersState, { user }) => ({
    ...state,
    currentUser: user
  })),

  on(updateUserinStore, (state: UsersState, { user }) => {
    const updatedUsers = state.allUsers.map(existingUser =>
      existingUser._id === user._id ? user : existingUser
    );

    return {
      ...state,
      allUsers: updatedUsers
    };
  }),
  on(updateOrderInvoice, (state: UsersState, { orderId, orderInvoice }) => {
    const updatedUsers = state.allUsers.map(user => {
      const updatedOrders = user.orders.map(order => 
        order._id === orderId ? { ...order, orderInvoice } : order
      );

      return {
        ...user,
        orders: updatedOrders,
      };
    });

    return {
      ...state,
      allUsers: updatedUsers,
    };
  }),
  on(deleteUserStore, (state: UsersState, { userId }) => ({
    ...state,
    allUsers: state.allUsers.filter(user => user._id !== userId)
  }))
);